import EventBus from '@/utils/EventBus.js'
const showFollowupTab = 'SHOW_FOLLOWUP_TAB' // 展示院内随访tab
// 刷新工单list
export const SHOW_FOLLOWUP_TAB = {
  on: callBack => {
    EventBus.on(showFollowupTab, callBack)
  },
  emit: flag => {
    EventBus.emit(showFollowupTab, flag)
  },
  off: () => {
    EventBus.off(showFollowupTab)
  }
}
